import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CatalogClient } from '../generated/api-client';

export {
  PersonDetailCatalogDto,
  DivineServiceTypeDto,
  CountryDto,
} from '../generated/api-client';

/**
 * Thin wrapper over the NSwag-generated CatalogClient.
 */
@Injectable({ providedIn: 'root' })
export class CatalogApiService {
  constructor(private readonly client: CatalogClient) {}

  getMemberDetailData() {
    return this.client.getMemberDetailData();
  }

  getDivineServiceTypes() {
    return this.client.getDivineServiceTypes();
  }

  getCountries() {
    return this.client.getCountries();
  }
}
